import { SelectableTileGroup } from '../../../components';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { MatchMakerAnswers } from '../../../../shared/types';
import { fuelList, isAvailableIn } from '../../helpers/vehicle-helpers';

export function FuelType(): JSX.Element {
  const { t } = useTranslation('match-maker');
  const { values } = useFormikContext<MatchMakerAnswers>();

  return (
    <SelectableTileGroup
      aria-required={true}
      itemList={fuelList(t)}
      itemColumnCount={[3, 6, 12]}
      inputType="checkbox"
      propName="fuelTypes"
      propObject={values.fuelTypes ?? []}
      required={true}
    />
  );
}
